import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgClose = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M15.55 5.625a.4.4 0 000-.566l-.609-.61a.4.4 0 00-.565 0L10 8.825 5.625 4.45a.4.4 0 00-.566 0l-.61.609a.4.4 0 000 .566L8.826 10 4.45 14.376a.4.4 0 000 .565l.609.61a.4.4 0 00.566 0L10 11.174l4.376 4.375a.4.4 0 00.565 0l.61-.609a.4.4 0 000-.566L11.175 10l4.376-4.375z" />
    </Icon>
  );
};

export default SvgClose;
